var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"tabIndex":_vm.disabled ? -1 : 0}}),_c('div',{attrs:{"tabIndex":_vm.disabled ? -1 : 1}}),_c('div',{ref:"lock"},[_vm._t("default")],2),_c('div',{attrs:{"tabIndex":_vm.disabled ? -1 : 0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }